export default __webpack_public_path__ + "static/media/prev-Multi-GNSS-Modules-2.7c3f40ca.png";